<template>
	<div class="content background1 background2" style="display: flex">
		<div class="tableBox9" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<el-tab-pane :label="$t('label_429')" name="first">
							<!-- <tree ref="tree0" :dataTree="treeData" @getDeviceMes="getDeviceMes"></tree> -->
							<template v-if="treeShow">
								<tree ref="tree0" :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"></tree>
							</template>
						</el-tab-pane>
						<el-tab-pane :label="this.$t('label_161')" name="second">
							<!-- <tree ref="tree1" :dataTree="treeData2" @getDeviceMes="getDeviceMes"></tree> -->
							<template v-if="treeShow">
								<tree ref="tree1" :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
							</template>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="checkAllMes" v-if="getTreeMes=='0'">
						<div class="statusMesList">
							<div class="statusNumList">
								<p><span class="square" style="background: #0353c1"></span>
									<span class="text">{{$t('label_451')}}</span>
									<!-- <span class="num" style="color: #0353c1">{{pageCount}}</span></p> -->
									<span class="num" style="color: #0353c1">{{checkCount.numInfoAll}}</span></p>
								<p><span class="square" style="background: #3fb393"></span>
									<span class="text">{{$t('label_455')}}</span>
									<span class="num" style="color: #3fb393">{{checkCount.status2}}</span></p>
								<p><span class="square" style="background: #ffb400"></span>
									<span class="text">{{$t('label_459')}}</span>
									<span class="num" style="color: #ffb400">{{checkCount.status1}}</span></p>
								<p><span class="square" style="background: #fe0000"></span>
									<span class="text">{{$t('label_461')}}</span>
									<span class="num" style="color: #fe0000">{{checkCount.status3}}</span></p>
								<p><span class="square" style="background: #aeaeae"></span>
									<span class="text">{{$t('label_464')}}</span>
									<span class="num" style="color: #aeaeae">{{checkCount.status0}}</span></p>
							</div>
							<div class="numListPro">
								<div v-for="item in checkCount.status2" style="background: #3fb393"></div>
								<div v-for="item in checkCount.status1" style="background: #ffb400"></div>
								<div v-for="item in checkCount.status3" style="background: #fe0000"></div>
								<div v-for="item in checkCount.status0" style="background: #aeaeae"></div>
							</div>
						</div>
						<div class="tableList">
							<div class="tableNum" style="margin-top: 110px;">
								<!-- <p class="p1" style="width:200px;">{{checkCount.numInfoAll}}</p> -->
								<!-- <p class="p1" style="width:200px;">{{pageCount}}</p>
								<p class="p2" style="width:200px">{{checkCount.status2 + checkCount.status1 + checkCount.status3 + checkCount.status0}}</p> -->
								<p class="p1" style="width:300px">{{checkCount.numInfoAll}}</p>
								<p class="p1" style="width:300px">{{checkCount.numMaintain}}</p>
								<!-- <p class="p2" style="width:200px">{{checkCount.numMaintainType}}</p> -->
							</div>
							<el-table :empty-text="$t('label_357')" ref="singleTable" :data="allTableData" highlight-current-row @current-change="handleCurrentChangeAll"
							 @row-dblclick="dbSelected" border style="width: 100%;" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
							 :height="height">
								<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
								</el-table-column>
								<el-table-column prop="pname" :label="$t('label_429')" align="center">
									<template slot-scope="scope">
										{{scope.row.pname}}
										<br>
										{{scope.row.name}}
									</template>
								</el-table-column>
								<!-- <el-table-column prop="name" label="设备型号" align="center">
								</el-table-column> -->
								<el-table-column prop="maintainBeginTime" :label="$t('label_470')" align="center">
									<template slot-scope="scope">
										<p v-if="scope.row.maintainBeginTime==null">--</p>
										<p v-if="scope.row.maintainBeginTime!=null">{{scope.row.maintainBeginTime.split(' ')[0]}}</p>
										<p v-if="scope.row.maintainBeginTime!=null">{{scope.row.maintainBeginTime.split(' ')[1].substring(0,8)}}</p>
									</template>
								</el-table-column>
								<el-table-column prop="maintainEndTime" :label="$t('label_473')" align="center">
									<template slot-scope="scope">
										<p v-if="scope.row.maintainEndTime==null">--</p>
										<p v-if="scope.row.maintainEndTime!=null">{{scope.row.maintainEndTime.split(' ')[0]}}</p>
										<p v-if="scope.row.maintainEndTime!=null">{{scope.row.maintainEndTime.split(' ')[1].substring(0,8)}}</p>
									</template>
								</el-table-column>
								<el-table-column prop="maintainStatus" :label="$t('label_475')" align="center">
									<template slot-scope="scope">
										<p :style="{'color':statusText[scope.row.maintainStatus==null?0:scope.row.maintainStatus].color}" style="font-weight: bold">
											{{statusText[scope.row.maintainStatus==null?0:scope.row.maintainStatus].text}}</p>
									</template>
								</el-table-column>
								<el-table-column prop="num" :label="$t('label_477')" align="center" width="200">
								</el-table-column>
								<el-table-column prop="maintainNum" :label="$t('label_479')" align="center" width="200">
								</el-table-column>
							</el-table>
							<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
							 @parentMethod="search1"></Page>
						</div>
					</div>
					<div class="checkAllMes" v-if="getTreeMes=='2'">
						<div class="tableList">
							<p class="title">{{$t('label_272')}}</p>
							<div class="tableNum" style="height: 42px;">
								<p class="p1" style="width:300px">{{checkCount.numInfoAll}}</p>
								<p class="p1" style="width:300px">{{checkCount.numMaintain}}</p>
								<!-- <p class="p2" style="width:300px">{{checkCount.numMaintain}}</p> -->
							</div>
							<el-table :empty-text="$t('label_357')" ref="singleTable" :data="allAreaData" highlight-current-row @current-change="handleCurrentChangeAll"
							 @row-dblclick="dbSelected" border style="width: 100%;" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
							 :height="height2">
								<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
								</el-table-column>
								<el-table-column prop="name" :label="$t('label_297')" align="left">
									<template slot-scope="scope">
										{{scope.row.dname}} {{scope.row.wname}}
										<br>
										{{scope.row.name}}
									</template>
								</el-table-column>
								<el-table-column prop="num" :label="$t('label_477')" align="center" width="300">
								</el-table-column>
								<el-table-column prop="maintainNum" :label="$t('label_479')" align="center" width="300">
								</el-table-column>
							</el-table>
							<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
							 @parentMethod="search0"></Page>
						</div>
					</div>

					<div class="treeMes" v-if="getTreeMes=='3'">
						<p class="title"><!-- {{deviceDetailMes.name}} --><span class="spot">
						{{deviceDetailMes.name != null ? "<" + deviceDetailMes.name + ">" : deviceDetailMes.name}}</span>
						</p>
						<div class="chooseBox">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText">
											<p>{{$t('label_481')}}</p>
										</div>
										<!-- <div class="select">
											<el-date-picker style="width: 210px;" type="date" value-format='yyyy-MM-dd' v-model="Readytime" placeholder="选择时间"></el-date-picker>
										</div> -->
										<div v-if="statusBtn==0">
											<el-date-picker style="width: 190px;" type="date" format="yyyy-MM-dd" value-format='yyyy-MM-dd' v-model="Readytime"
											 :placeholder="$t('input_91')" :disabled="true"></el-date-picker>
										</div>
										<div v-if="statusBtn==1">
											<el-date-picker style="width: 190px;" type="date" format="yyyy-MM-dd" value-format='yyyy-MM-dd' v-model="Readytime"
											 :placeholder="$t('input_91')" :picker-options="pickerOptions"></el-date-picker>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div>
									<!-- <div class="chooseButton2 searchButton" @click="start(0)">启用</div>
									<div class="chooseButton2" @click="start(1)">停用</div> -->
									<div v-if="statusBtn==0">
										<div class="chooseButton2 searchButton" style="cursor: not-allowed;" v-if="MenuRoleList.indexOf('117')>=0">{{$t('btn_36')}}</div>
										<div class="chooseButton2 deleteButton" @click="start(1)" v-if="MenuRoleList.indexOf('118')>=0">{{$t('btn_37')}}</div>
									</div>
									<div v-if="statusBtn==1">
										<div class="chooseButton2 searchButton" @click="start(0)" v-if="MenuRoleList.indexOf('117')>=0">{{$t('btn_36')}}</div>
										<div class="chooseButton2 deleteButton" style="cursor: not-allowed;" v-if="MenuRoleList.indexOf('118')>=0">{{$t('btn_37')}}</div>
										<div class="chooseButton2 searchButton" @click="resetHandle()" v-if="deviceDetailMes.type == 1">
                      {{ $t('btn_69') }} </div>
									</div>
								</div>
							</div>
						</div>
						<div class="spotMesBox">
							<el-tabs v-model="activeNameDevice" @tab-click="handleClickDevice">
								<el-tab-pane :label="$t('label_483')" name="device" style="height: 100%;" v-if="MenuRoleList.indexOf('107')>=0">
									<div class="buttonBox">
										<div>
											<div class="chooseButton searchButton" @click="tableDataTreeInfoEdit" v-if="MenuRoleList.indexOf('108')>=0"><i
												 class="el-icon-edit-outline"></i>{{$t('btn_15')}}
											</div>
										</div>
									</div>
									<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableMaintainTeamData" highlight-current-row @current-change="handleCurrentChangeTree"
									 border style="width: 100%;margin: 10px 0" height="86%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
										<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
										</el-table-column>
										<el-table-column prop="ename" :label="$t('label_1')" align="left" v-if="deviceDetailMes.type==2">
											<template slot-scope="scope">
												<span v-for="(item,index) in scope.row.typeName">{{item}} </span>
												<br> {{scope.row.ename}}
												<br> {{scope.row.code}}
											</template>
										</el-table-column>
										<el-table-column prop="name" :label="$t('label_483')" align="left">
											<template slot-scope="scope">
												<span style="font-size: 16px; font-weight: 600;">
													{{scope.row.name}}
												</span>
												<br>
												<popMesBox :popMes="scope.row.content" :hoverMes="scope.row.content" :popWidth="200"></popMesBox>
											</template>
										</el-table-column>
										<el-table-column prop="planDay" :label="$t('label_494')" align="center">
											<template slot-scope="scope">
												{{scope.row.planDay}}{{$t('label_537')}}
											</template>
										</el-table-column>
										<el-table-column prop="maintainChargeName" :label="$t('label_496')" align="center">
										</el-table-column>
										<el-table-column prop="cycle" :label="$t('label_499')" align="center">
											<template slot-scope="scope">
												<p v-if="scope.row.cycleType==1 && scope.row.cycle==0 ">{{$t('label_652')}}</p>
												<p v-if="scope.row.cycleType==1 && scope.row.cycle!=0 ">{{$t('label_531')}}{{scope.row.cycle}}{{$t('label_537')}}</p>
												<p v-if="scope.row.cycleType==2 ">{{weekendMesOptions[scope.row.cycle].label}}</p>
												<p v-if="scope.row.cycleType==3 ">{{$t('label_654')}}{{scope.row.cycle}}{{$t('label_537')}}</p>
												<p v-if="scope.row.cycleType==4 && scope.row.cycle!=0 ">{{$t('label_935')}}{{scope.row.cycle}}{{$t('label_534')}}</p>
												<p v-if="scope.row.cycleType==5">{{$t('label_935')}}{{scope.row.cycle.split(',')[0]}}{{$t('label_540')}}{{scope.row.cycle.split(',')[1]}}{{$t('label_542')}}{{scope.row.cycle.split(',')[2]}}{{$t('label_537')}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="sort" :label="$t('label_501')" align="center">
											<template slot-scope="scope">
												<el-button type="text" size="small" @click="moveUp(scope.row, scope.$index)" :disabled="scope.$index === 0"
												 style="font-size: 20px"><i class="el-icon-arrow-up"></i>
												</el-button>
												<el-button type="text" size="small" style="font-size: 20px" @click="moveDown(scope.row, scope.$index)"
												 :disabled="getFormLength(scope.$index)"><i class="el-icon-arrow-down"></i>
												</el-button>
											</template>
										</el-table-column>
									</el-table>
									<Page class="item" ref="tableMaintainTeamDataPageModel" :total="pageCount" :display="pageSize" :pagegroup="3"
									 :currentspage="1" @parentMethod="search"></Page>
								</el-tab-pane>
								<el-tab-pane :label="$t('label_587')" name="devicetime" style="height: 100%;" v-if="MenuRoleList.indexOf('109')>=0">
									<div class="buttonBox">
										<div>
											<div class="chooseButton searchButton" @click="addMaintainGroupdialog" v-if="MenuRoleList.indexOf('110')>=0"><i
												 class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}
											</div>
											<div class="chooseButton deleteButton" @click="deleteMaintainGroup()" v-if="MenuRoleList.indexOf('111')>=0"><i
												 class="el-icon-delete"></i>{{$t('btn_16')}}</div>
											<div class="chooseButton searchButton" @click="acquiescence()" v-if="MenuRoleList.indexOf('111')>=0"><i
												 class="el-icon-refresh"></i>{{$t('btn_25')}}</div>
										</div>
									</div>
									<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableGroup" highlight-current-row @current-change="handleCurrentChangeTreeTime"
									 border style="width: 100%;margin: 10px 0" height="86%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
										<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
										</el-table-column>
										<el-table-column prop="workerNumber" :label="$t('label_559')" align="center">
										</el-table-column>
										<el-table-column prop="fullName" :label="$t('label_496')" align="center">
										</el-table-column>
										<!-- <el-table-column prop="skillALL" label="特种技能" align="center">
											<template slot-scope="scope">
												<span v-for="item in  (scope.row.skillALL==null?[]:scope.row.skillALL.split(','))">
													{{riskMap[item]}}
												</span>
											</template>
										</el-table-column> -->
										<!-- <el-table-column prop="certificateName" label="特种技能证件" align="center">
										</el-table-column>
										<el-table-column prop="certificateValidity" label="证件有效期" align="center">
										</el-table-column> -->
										<el-table-column prop="mobile" :label="$t('label_569')" align="center">
										</el-table-column>
										<el-table-column prop="deptName" :label="$t('label_567')" align="center">
										</el-table-column>
									</el-table>
									<Page class="item" ref="pageModelGroup" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
									 @parentMethod="searchGroup"></Page>
								</el-tab-pane>

								<el-tab-pane :label="$t('btn_59')" name="devicerest" style="height: 100%" v-if="MenuRoleList.indexOf('112')>=0">
									<calendar ref="calendarDisplay" :showButton="MenuRoleList.indexOf('418') != -1" :showEdit="statusBtn != 0" @saveRest="saveRest"
									 :calendarData="calendarData" @selectRest="selectRest"></calendar>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>

				</div>
			</div>
		</div>

		<el-dialog v-loading="saveLoading" :title="$t('btn_15')" :visible.sync="dialogDeviceSpot" append-to-body :close-on-click-modal='false' width="900px" top="10%"
		 :before-close="handleCloseEdit" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<p>{{$t('label_483')}}</p>
					<div class="mesInput" style="width: 740px">
						<el-input type="textarea" rows="1" maxlength="20" v-model="tableDataEdit.name" disabled></el-input>
					</div>
				</div>
				<div class="dialogMes">
					<p style="width: 170px;"><span style="color: #ff0000">*</span>{{$t('label_518')}}</p>
					<div class="mesInput" style="width: 740px">
						<el-checkbox-group v-model="tableDataEdit.risk" disabled>
							<el-checkbox v-for="item in riskList" :label="item" :key="item"></el-checkbox>
							<!-- <el-checkbox label="攀高"></el-checkbox>
							<el-checkbox label="电工"></el-checkbox>
							<el-checkbox label="高空"></el-checkbox>
							<el-checkbox label="动火"></el-checkbox> -->
						</el-checkbox-group>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_506')}}</p>
					<div class="mesInput" style="width: 740px">
						<el-input type="textarea" :placeholder="$t('input_46')" maxlength="500" rows="4" show-word-limit v-model="tableDataEdit.content"
						 disabled></el-input>
					</div>
				</div>
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_509')}}</p>
					<div class="mesInput" style="display: flex;width: 740px;justify-content: flex-start;flex-wrap: wrap">
<!--						<div class="chooseList">-->
<!--							<el-radio v-model="tableDataEdit.cycleType" label="4" disabled>-->
<!--								{{$t('label_531')}}-->
<!--								<el-input v-model="tableDataEdit.hour" style="width: 100px" disabled></el-input>-->
<!--								{{$t('label_534')}}-->
<!--							</el-radio>-->
<!--						</div>-->
						<div class="chooseList">
							<el-radio v-model="tableDataEdit.cycleType" label="2" disabled>
								<el-select v-model="tableDataEdit.weekend" @change="$forceUpdate()" style="width: 110px" filterable :placeholder="$t('input_65')"
								 disabled>
									<el-option v-for="item in weekendMesOptions" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
							</el-radio>
						</div>
						<div class="chooseList">
							<el-radio v-model="tableDataEdit.cycleType" label="3">
								<el-select style="width: 90px" v-model="tableDataEdit.month" filterable :placeholder="$t('input_65')" disabled @change="changeSelectMonth">
									<el-option v-for="(item,index) in monthOptions" :key="index" :label="item" :value="item">
									</el-option>
								</el-select>
								<el-select style="width: 90px" @change="$forceUpdate()" v-model="tableDataEdit.monthDD" :placeholder="$t('input_65')"
								 disabled>
									<el-option v-for="(item,index) in monthDOptions" :key="index" :label="item" :value="item" />
								</el-select>
							</el-radio>
						</div>
						<div class="chooseList">
							<el-radio v-model="tableDataEdit.cycleType" label="1" disabled>{{$t('label_531')}}
								<el-input v-model="tableDataEdit.cycle" style="width: 100px" disabled></el-input>
								{{$t('label_537')}}
							</el-radio>
						</div>
						<div class="chooseList">
							<el-radio v-model="tableDataEdit.cycleType" label="5" disable>
								{{$t('label_935')}}
								<el-select style="width: 90px" @change="$forceUpdate()" v-model="tableDataEdit.year" disabled filterable
								 :placeholder="$t('input_65')">
									<el-option v-for="(item,index) in 10" :key="index" :label="item" :value="item">
									</el-option>
								</el-select>
								{{$t('label_540')}}
								<el-select style="width: 90px" @change="$forceUpdate()" v-model="tableDataEdit.yearmonth" disabled :placeholder="$t('input_65')">
									<el-option v-for="(item,index) in 12" :key="index" :label="item" :value="item" />
								</el-select>
								{{$t('label_542')}}
								<el-select style="width: 90px" @change="$forceUpdate()" v-model="tableDataEdit.yearmonthD" disabled :placeholder="$t('input_65')">
									<el-option v-for="(item,index) in 31" :key="index" :label="item" :value="item" />
								</el-select>
								{{$t('label_537')}}
							</el-radio>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<div class="dialogMes">
						<p><span style="color: #ff0000">*</span>{{$t('label_494')}}</p>
						<div class="mesInput" style="width: 150px;display: flex">
							<el-input show-word-limit v-model="tableDataEdit.planDay" disabled></el-input>
							<p>{{$t('label_545')}}</p>
						</div>
					</div>
					<div class="dialogMes" style="margin-left: 25px">
						<p style="text-align: right"><span style="color: #ff0000">*</span>{{$t('label_547')}}</p>
						<div class="mesInput" style="width: 200px;display: flex">
<!--							<p style="text-align: right">{{$t('label_550')}}</p>-->
							<el-input placeholder="请输入内容" show-word-limit v-model="tableDataEdit.warningDay" disabled></el-input>
							<p style="width: 140px;">{{$t('label_545')}}</p>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_496')}}</p>
					<div class="mesInput" style="width: 560px;">
						<!-- <el-input placeholder="请点击按钮选择" show-word-limit v-model="tableDataEdit.maintainChargeName"><i slot="suffix" class="el-input__icon el-icon-search"
							 style="font-size: 20px;cursor: pointer;" @click="addMaintainGroupdialog"></i></el-input> -->
						<el-select v-model="selectValue" multiple filterable :placeholder="$t('input_66')" :remote-method="remoteMethod" :loading="loading">
							<el-option v-for="item in options" :key="item.id" :label="item.fullName" :value="`${item.fullName}&@${item.id}`">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="dialogMes">
					<p v-if="$store.getters.getVersions == 2" style="width: 100px;line-height: 25px">{{$t('label_555')}}(E-SOP)</p>
          <p v-else style="width: 100px;line-height: 25px">{{$t('label_555')}}</p>
					<div class="mesInput">
						<div class="box" style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px;margin-left: 20px;">
							<el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :show-file-list="false"
							 :http-request="upload" disabled>
								<i class="el-icon-upload" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
							</el-upload>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="tableDataEditSave">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>

		<el-dialog :title="$t('label_587')" ref="multipleTable" :visible.sync="dialogAddMaintainGroup" append-to-body
		 :close-on-click-modal='false' width="1000px" top="12%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="chooseBox" style="height: 100px">
					<div class="selectBox selectGroup" style="justify-content: space-between">
						<div>
							<div class="selectChoose" style="width: 300px;">
								<div class="selectText">
									<p>{{$t('label_559')}}</p>
								</div>
								<div class="select">
									<el-input v-model="searchBao.workerNumber" :placeholder="$t('input_49')"></el-input>
								</div>
							</div>
						</div>
						<div>
							<div class="selectChoose" style="width: 300px;">
								<div class="selectText">
									<p>{{$t('label_563')}}</p>
								</div>
								<div class="select">
									<el-input v-model="searchBao.fullName" :placeholder="$t('input_49')"></el-input>
								</div>
							</div>
						</div>
						<div>
							<div class="selectChoose" style="width: 300px;">
								<div class="selectText">
									<p>{{$t('label_567')}}</p>
								</div>
								<div class="select">
									<el-input v-model="searchBao.deptName" :placeholder="$t('input_49')"></el-input>
								</div>
							</div>
						</div>
						<div>
							<div class="selectChoose" style="width: 300px;">
								<div class="selectText">
									<p>{{$t('label_569')}}</p>
								</div>
								<div class="select">
									<el-input v-model="searchBao.mobile" :placeholder="$t('input_49')"></el-input>
								</div>
							</div>
						</div>
						<!-- <div>
							<div class="selectChoose">
								<div class="selectText">
									<p>角色</p>
								</div>
								<div class="select">
									<el-select v-model="searchBao.roleId" filterable :placeholder="$t('input_65')">
										<el-option label="全部" value="0"></el-option>
										<el-option v-for="(item,index) in roleList" :label="item.roleName" :value="item.roleId" :key="item.roleId"></el-option>
									</el-select>
								</div>
							</div>
						</div> -->
						<div>
							<div class="selectChoose" style="width: 300px;justify-content: right">
								<div>
									<div class="chooseButton sendButton" @click="searchUser({pageNum: 1,pageSize: pageSizeGroup})"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>

					</div>
				</div>
				<!-- <div class="dialogMes">
					<p><span style="color: #ff0000">*</span>特种技能</p>
					<div class="mesInput" style="width: 640px">
						<el-checkbox-group v-model="searchBao.skill">
							<el-checkbox v-for="(item,index) in riskList" :label="item.key" :key="item.key">{{item.val}}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div> -->
				<div class="buttonBox" style="border-top:1px solid #dedede">
					<div>
						<div class="chooseButton searchButton" style="margin: 10px 0" @click="addMaintainGroup"><i class="el-icon-s-claim"></i>{{$t('btn_39')}}</div>
					</div>
				</div>
				<el-table :empty-text="$t('label_357')" ref="singleTable" :data="userRisk" highlight-current-row @select="handleSelectionChange" row-key="1"
				 border style="width: 100%;margin: 10px" height="240px" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
					<el-table-column type="selection" width="55" align="center">
					</el-table-column>
					<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex2" width="50">
					</el-table-column>
					<el-table-column prop="workerNumber" :label="$t('label_559')" align="center">
					</el-table-column>
					<el-table-column prop="fullName" :label="$t('label_563')" align="center">
					</el-table-column>
					<el-table-column prop="deptName" :label="$t('label_567')" align="center">
					</el-table-column>
					<el-table-column prop="mobile" :label="$t('label_569')" align="center">
					</el-table-column>
					<!-- <el-table-column prop="roleName" label="角色" align="center">
					</el-table-column>
					<el-table-column prop="skillALL" label="特种技能" align="center">
						<template slot-scope="scope">
							<span v-for="item in  (scope.row.skillALL==null?[]:scope.row.skillALL.split(','))">
								{{riskMap[item]}}
							</span>
						</template>
					</el-table-column> -->
					<!-- <el-table-column prop="certificateName" label="特种技能证件" align="center">
					</el-table-column>
					<el-table-column prop="certificateValidity" label="证件有效期" align="center">
					</el-table-column> -->
				</el-table>
				<Page class="item" ref="pageModelGroup2" :total="pageCountGroup" :display="pageSizeGroup" :pagegroup="3"
				 :currentspage="1" @parentMethod="searchUser"></Page>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import file from "@/assets/js/file/file.js";
	import tree from "@/components/list/tree/maintainTree";
	import maintenance from "@/assets/js/maintenance/maintenance.js";
	import Role from "@/assets/js/role/role.js";
	import popMesBox from "@/components/list/popover/pop";
	export default {
		name: 'maintainPlanPage',
		components: {
			Page,
			tree,
			calendar,
			popMesBox
		},
		data() {
			return {
        saveLoading: false,
				selectValue: [],
				options: [],
				loading: false,

				pickerOptions: {
					disabledDate(date) {
						//disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
						return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
					}
				},
				treeShow: true,
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				pageNumGroup: 1,
				pageSizeGroup: 10,
				pageCountGroup: 0,
				Readytime: '',
				statusBtn: '',
				height: 600,
				height2: 730,
				getTreeMes: '2',
				baoyangChoose: '0',
				checked: false,
				dialogDeviceSpot: false,
				dialogAddMaintainGroup: false,
				tableDataTreeEdit: {},
				calendarData: [],
				MenuRoleList: [],
				calendarList: {
					id: '',
					type: '',
					year: ''
				},
				searchBao: {
					code: '',
					fullname: '',
					part: '',
					mobile: '',
					roleId: '0',
					skill: [],
				},
				checkList: [],
				tableDataTreeBatchTimeEdit: {
					start: '00:00:00',
					end: '00:00:00',
					once: '',
					onceTime: '',
				},
				tableDataTreeInfo: {},
				tableDataTreeTimeInfo: {},
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: true,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				spotFunOptions: [{
					value: '0',
					label: '目视'
				}],
				weekendMesOptions: [{
					value: '0',
					label: this.$t('label_716')
				}, {
					value: '1',
					label: this.$t('label_719')
				}, {
					value: '2',
					label: this.$t('label_721')
				}, {
					value: '3',
					label: this.$t('label_723')
				}, {
					value: '4',
					label: this.$t('label_725')
				}, {
					value: '5',
					label: this.$t('label_728')
				}, {
					value: '6',
					label: this.$t('label_730')
				}, ],
				monthDOptions: [],
				monthOptions: [this.$t('label_245'), this.$t('label_242'), this.$t('label_238')],
				monthOptionsObj: {
					// "每月初": ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
					// "每月中": ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
					// "每月末": ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
				},
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				checkCount: [],
				tableMaintainTeamData: [],
				allTableData: [],
				allAreaData: [],
				tableGroup: [],
				tableDataTree: [],
				tableDataTreeTime: [{
					startTime: '08:00',
					endTime: '09:00',
					time: '10',
					status: 0
				}, {
					startTime: '10:00',
					endTime: '08:00',
					time: '10',
					status: 1
				}, {
					startTime: '08:00',
					endTime: '09:00',
					time: '10',
					status: 0
				}],
				statusText: [{
						id: '3',
						text: this.$t('label_447'),
						color: '#000000'
					},
					{
						id: '2',
						text: this.$t('label_443'),
						color: '#ffb400'
					}, {
						id: '0',
						text: this.$t('btn_36'),
						color: '#3fb393'
					},
					{
						id: '1',
						text: this.$t('btn_37'),
						color: '#fe0000'
					},


				],
				activeNameTree: 'second',
				activeNameSpot: 'spot',
				activeNameDevice: 'device',
				roleList: [],
				riskList: [],
				riskMap: {},
				userRisk: [],
				selectionChange: [],
				id: '',
				deviceDetailMes: {},
				tableDataEdit: {
					changeState: 0,
					content: "",
					cycle: "",
					cycleType: '4',
					equipmentId: '',
					fileId: '',
					name: "",
					pid: 0,
					planDay: '',
					hour: '',
					remark: "",
					risk: [],
					sort: 0,
					warningDay: "",
					weekend: '0',
					month: this.$t('label_245'),
					monthD: '1',
					monthDD: '1',
					monthDMes: '1',
				},
				searchAcquiescence: {},
				width: '340px',
				qrCodeShow: false,
			}
		},
		methods: {
			acquiescence() {
				if (this.statusBtn != 0) {
					var type = 0;
					if (this.activeNameTree == 'second') {
						type = 2;
					}
					let param = {
						type: this.searchAcquiescence.type,
						id: this.searchAcquiescence.id,
						pidType: type,
						pid: this.searchAcquiescence.pid,
					}
					maintenance.acquiescence(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchMaintainGroup({
								pageNum: 1,
								pageSize: this.pageSize,
								id: this.deviceDetailMes.id,
								type: this.deviceDetailMes.type
							});
							this.$message({
								message: this.$t('msg_23'),
								type: 'success'
							});
						}
					}).catch((response) => {
						this.loading = false;
						console.log(response)
					})
				} else {
					utils.messageAlert(this.$t('label_836'), this.$t('label_358'), this.$t('label_100'));
				}

			},
			remoteMethod(query) {
				// if (query !== '') {
				this.loading = true;
				file.selectUser(query).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.loading = false;
						this.options = data.data;
					}
				}).catch((response) => {
					this.loading = false;
					console.log(response)
				})
				// } else {
				// 	this.options = [];
				// }
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			getIndex2(index) {
				return (this.pageNumGroup - 1) * this.pageSizeGroup + index + 1
			},
			handleClose() {
				this.dialogAddMaintainGroup = false;
			},
			handleCloseEdit() {
				this.dialogDeviceSpot = false;
			},
			moveUp(item, index) {
				let param = {
					id: item.id,
					sort: item.sort,
					id2: this.tableMaintainTeamData[index - 1].id,
					sort2: this.tableMaintainTeamData[index - 1].sort
				}
				if (this.deviceDetailMes.type == 1 || this.deviceDetailMes.type == 2) {
					file.sortEquipmentMaintainInfo(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchMaintain({
								pageNum: 1,
								pageSize: this.pageSize,
								deviceId: this.deviceDetailMes.id
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					file.sortEquipmentTypeMaintainInfo(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchMaintainType({
								pageNum: 1,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				}
			},
			// 下移
			moveDown(item, index) {
				let param = {
					id: item.id,
					sort: item.sort,
					id2: this.tableMaintainTeamData[index + 1].id,
					sort2: this.tableMaintainTeamData[index + 1].sort
				}
				if (this.deviceDetailMes.type == 1 || this.deviceDetailMes.type == 2) {
					file.sortEquipmentMaintainInfo(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchMaintain({
								pageNum: 1,
								pageSize: this.pageSize,
								deviceId: this.deviceDetailMes.id
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					file.sortEquipmentTypeMaintainInfo(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchMaintainType({
								pageNum: 1,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				}
			},
			// 控制下移按钮的显示于隐藏
			getFormLength(index) {
				if (index === this.tableMaintainTeamData.length - 1) return true;
				else return false;
			},
			handleCurrentChangeAll(info) {},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			changeSelectMonth() {
				this.tableDataEdit.monthD = '';
				for (const k in this.monthOptions) {
					if (this.tableDataEdit.month === this.monthOptions[k]) {
						this.monthDOptions = this.monthOptionsObj[this.tableDataEdit.month]
					}
				}
			},
			tableDataEditSave() {
        this.saveLoading = true;
				let param = {
					id: '',
					maintainChargeId: '',
					maintainChargeName: ''
				};
				param.id = this.tableDataEdit.id;
				// param.maintainChargeId = this.tableDataEdit.maintainChargeId;
				// param.maintainChargeName = this.tableDataEdit.maintainChargeName;
				// if (this.selectValue.length == 0) {
				// 	this.$message({
				// 		message: '请填写保养担当',
				// 		type: 'warning'
				// 	});
				// }
				let maintainChargeName = "";
				let maintainChargeId = "";

				if (this.selectValue.length > 0) {
					for (let v of this.selectValue) {
						let arr = v.split("&@");
						maintainChargeName += "," + arr[0];
						maintainChargeId += "," + arr[1];
					}
				}

				param.maintainChargeName = maintainChargeName.substring(1);
				param.maintainChargeId = maintainChargeId.substring(1);
				if (this.deviceDetailMes.type == '0') {
					file.saveEquipmentTypeMaintainInfoEdit(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogDeviceSpot = false;
							this.selectValue = [];
							this.tableDataEdit = {
								changeState: 0,
								content: "",
								cycle: "",
								cycleType: '4',
								equipmentTypeId: '',
								fileId: '',
								hour: '',
								name: "",
								pid: 0,
								planDay: '',
								remark: "",
								risk: [],
								sort: 0,
								warningDay: "",
								weekend: '0',
								month: this.$t('label_245'),
								monthD: '1',
								monthDD: '1',
								monthDMes: '1',
							}
							this.$message({
								message: this.$t('msg_23'),
								type: 'success'
							});
							this.searchMaintainType({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						} else {
							this.$message({
								message: this.$t('msg_77'),
								type: 'error'
							});
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				} else {
					file.saveEquipmentMaintainInfoEdit(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogDeviceSpot = false;
							this.selectValue = [];
							this.tableDataEdit = {
								changeState: 0,
								content: "",
								cycle: "",
								cycleType: '4',
								equipmentId: '',
								fileId: '',
								hour: '',
								name: "",
								pid: 0,
								planDay: '',
								remark: "",
								risk: [],
								sort: 0,
								warningDay: "",
								weekend: '0',
								month: this.$t('label_245'),
								monthD: '1',
								monthDD: '1',
								monthDMes: '1',
							}
							this.searchMaintain({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
							this.$message({
								message: this.$t('msg_23'),
								type: 'success'
							});
						} else {
							this.$message({
								message: this.$t('msg_77'),
								type: 'error'
							});
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				}
			},
			tableDataTreeInfoEdit() {
				this.remoteMethod('');
				if (this.statusBtn != 0) {
					if (Object.keys(this.tableDataTreeInfo).length > 0) {
						this.dialogDeviceSpot = true;
						if (this.deviceDetailMes.type == 1 || this.deviceDetailMes.type == 2) {
							file.getEquipmentMaintainInfoMes(this.tableDataTreeInfo.id).then((response) => {
								const data = response.data;
								if (data.code == "1") {
									if (data.data.maintainChargeName != null) {
										let maintainChargeNameArr = data.data.maintainChargeName.split(",");
										let maintainChargeIdArr = data.data.maintainChargeId.split(",");
										let selectValue = [];
										let options = [];
										for (let i = 0; i < maintainChargeIdArr.length; i++) {
											if (maintainChargeIdArr[i] != "") {
                        let names = this.options.find(item => item.id === maintainChargeIdArr[i])
												selectValue.push(names.fullName + "&@" + maintainChargeIdArr[i]);
												options.push({
													id: maintainChargeIdArr[i],
													fullName: maintainChargeIdArr[i]
												})
											}
										}
										//this.options = options;
										this.selectValue = selectValue;
									} else {
										//this.options = [];
										this.selectValue = [];
									}

									this.tableDataEdit = data.data;
									if (this.tableDataEdit.cycleType == '1') {

									} else if (this.tableDataEdit.cycleType == '2') {
										this.tableDataEdit.weekend = this.tableDataEdit.cycle.toString();
										this.tableDataEdit.cycle = '';
									} else if (this.tableDataEdit.cycleType == '3') {
										let monthss = Number(this.tableDataEdit.monthDD);
										if (monthss > 20) {
											this.tableDataEdit.month = this.$t('label_238')
										} else if (monthss > 10) {
											this.tableDataEdit.month = this.$t('label_242')
										} else {
											this.tableDataEdit.month = this.$t('label_245')
										}
										this.tableDataEdit.monthDD = this.tableDataEdit.cycle.toString();
										this.tableDataEdit.cycle = '';
									} else if (this.tableDataEdit.cycleType == '4') {
										this.tableDataEdit.hour = this.tableDataEdit.cycle.toString();
										this.tableDataEdit.cycle = '';
									} else if (this.tableDataEdit.cycleType == '5') {
										this.tableDataEdit.year = this.tableDataEdit.cycle.split(',')[0];
										this.tableDataEdit.yearmonth = this.tableDataEdit.cycle.split(',')[1];
										this.tableDataEdit.yearmonthD = this.tableDataEdit.cycle.split(',')[2];
										this.tableDataEdit.cycle = '';
									}
									this.tableDataEdit.cycleType = this.tableDataEdit.cycleType.toString();
									// this.tableDataEdit.risk =this.tableDataEdit.risk.split(',')
									this.tableDataEdit.risk = JSON.parse(this.tableDataEdit.risk)
									this.dialogDeviceSpot = true;
								} else {
									utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
								}
							}).catch((response) => {
								console.log(response)
							})
						} else if (this.deviceDetailMes.type == 0) {
							file.getEquipmentTypeMaintainInfoMes(this.tableDataTreeInfo.id).then((response) => {
								const data = response.data;
								if (data.code == "1") {
									if (data.data.maintainChargeName != null) {
										let maintainChargeNameArr = data.data.maintainChargeName.split(",");
										let maintainChargeIdArr = data.data.maintainChargeId.split(",");
										let selectValue = [];
										let options = [];
										for (let i = 0; i < maintainChargeNameArr.length; i++) {
											if (maintainChargeNameArr[i] != "") {
												selectValue.push(maintainChargeNameArr[i] + "&@" + maintainChargeIdArr[i]);
												options.push({
													id: maintainChargeIdArr[i],
													fullName: maintainChargeNameArr[i]
												})
											}

										}
										//this.options = options;
										this.selectValue = selectValue;
									} else {
										//this.options = [];
										this.selectValue = [];
									}

									this.tableDataEdit = data.data;
									if (this.tableDataEdit.cycleType == '1') {

									} else if (this.tableDataEdit.cycleType == '2') {
										this.tableDataEdit.weekend = this.tableDataEdit.cycle.toString();
										this.tableDataEdit.cycle = '';
									} else if (this.tableDataEdit.cycleType == '3') {
										let monthss = Number(this.tableDataEdit.monthDD);
										if (monthss > 20) {
											this.tableDataEdit.month = this.$t('label_238')
										} else if (monthss > 10) {
											this.tableDataEdit.month = this.$t('label_242')
										} else {
											this.tableDataEdit.month = this.$t('label_245')
										}
										this.tableDataEdit.monthDD = this.tableDataEdit.cycle.toString();
										this.tableDataEdit.cycle = '';
									} else if (this.tableDataEdit.cycleType == '4') {
										this.tableDataEdit.hour = this.tableDataEdit.cycle.toString();
										this.tableDataEdit.cycle = '';
									} else if (this.tableDataEdit.cycleType == '5') {
										this.tableDataEdit.year = this.tableDataEdit.cycle.split(',')[0];
										this.tableDataEdit.yearmonth = this.tableDataEdit.cycle.split(',')[1];
										this.tableDataEdit.yearmonthD = this.tableDataEdit.cycle.split(',')[2];
										this.tableDataEdit.cycle = '';
									}
									this.tableDataEdit.cycleType = this.tableDataEdit.cycleType.toString();
									// this.tableDataEdit.risk =this.tableDataEdit.risk.split(',')
									this.tableDataEdit.risk = JSON.parse(this.tableDataEdit.risk)
									this.dialogDeviceSpot = true;
								} else {
									utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
								}
							}).catch((response) => {
								console.log(response)
							})
						}
						this.selectRisk(this.tableDataTreeInfo)
					} else {
						utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
					}
				} else {
					utils.messageAlert(this.$t('label_836'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			handleCurrentChangeTreeTime(info) {
				this.id = info.id;
			},
			handleNodeClickDevice(data) {
				if (data.label == this.$t('label_272')) {
					this.getTreeMes = '0';
				} else {
					this.getTreeMes = '1';
				}
			},
			handleNodeClickArea(data) {
				if (data.label == this.$t('label_272')) {
					this.getTreeMes = '2';
				} else {
					this.getTreeMes = '3';
				}
			},
			handleClickTree(tab, event) {

				if (tab.label == this.$t('label_161')) {
					this.getTreeMes = '2';
					this.searchPage({
						pageNum: 1,
						pageSize: this.pageSize,
						type: 0,
					});
				} else {
					this.getTreeMes = '0';
					this.searchPage({
						pageNum: 1,
						pageSize: this.pageSize,
						type: 1,
					});
				}
			},
			handleClickSpot(tab, event) {
				// console.log(tab, event);
			},
			handleClickDevice(tab, event) {
				// console.log(tab, event);
				if (tab.name == 'devicetime') {
					this.searchMaintainGroup({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				} else if (tab.name == 'device') {
					if (this.deviceDetailMes.type == '0') {
						this.searchMaintainType({
							pageNum: 1,
							pageSize: this.pageSize,
						});
					} else {
						this.searchMaintain({
							pageNum: 1,
							pageSize: this.pageSize,
						});
					}
				}

			},
			saveRest(param) {
				var dataParam = {
					id: this.deviceDetailMes.id,
					type: this.deviceDetailMes.type
				}
				var newParam = Object.assign(param, dataParam);
				maintenance.saveMaintainRest(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.$message({
							message: this.$t('msg_21'),
							type: 'success'
						});
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectRest(param) {
				var dataParam = {
					id: this.deviceDetailMes.id,
					type: this.deviceDetailMes.type
				}
				var newParam = Object.assign(param, dataParam);
				file.selectEquipmentaintainRest(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.calendarData = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			search0(param) {
				param.type = 0;
				this.searchPage(param);
			},
			search1(param) {
				param.type = 1;
				this.searchPage(param);
			},
			search(param) {
				// this.searchMaintain(param);
				if (this.deviceDetailMes.type == '1') {
					if (this.activeNameDevice == 'devicetime') {
						this.searchMaintainGroup(param);
					} else if (this.activeNameDevice == 'device') {
						this.searchMaintain(param);
					}
				} else if (this.deviceDetailMes.type == '2') {
					if (this.activeNameDevice == 'devicetime') {
						this.searchMaintainGroup(param);
					} else if (this.activeNameDevice == 'device') {
						this.searchMaintain(param);
					}
				} else if (this.deviceDetailMes.type == '0') {
					if (this.activeNameDevice == 'devicetime') {
						this.searchMaintainGroup(param);
					} else if (this.activeNameDevice == 'device') {
						this.searchMaintainType(param);
					}
				}
			},
			searchGroup(param) {
				this.searchMaintainGroup(param);
			},
			getDeviceMes(data) {
				this.tableMaintainTeamData = [];
				this.tableGroup = [];
				if (data.name == this.$t('label_272')) {
					if (this.activeNameTree == 'second') {
						this.getTreeMes = '2';
						this.searchPage({
							pageNum: 1,
							pageSize: this.pageSize,
							type: 0,
						});
					} else {
						this.getTreeMes = '0';
						this.searchPage({
							pageNum: 1,
							pageSize: this.pageSize,
							type: 1,
						});
					}
				} else {
					this.searchAcquiescence = data;
					this.deviceDetailMes = data;
					if (data.maintainStatus == "1" || data.maintainStatus == "2") {
						this.statusBtn = 0;
						this.Readytime = data.mtime.substring(0, 10)
					} else {
						this.statusBtn = 1;
						this.Readytime = this.getNowTime();
					}
					if (data.type == '1') {
						this.getTreeMes = '3';
						//设备
						if (this.activeNameDevice == 'devicetime') {
							this.searchMaintainGroup({
								pageNum: 1,
								pageSize: this.pageSize,
							});
						} else if (this.activeNameDevice == 'device') {
							this.searchMaintain({
								pageNum: 1,
								pageSize: this.pageSize,
							});
						}
					} else if (data.type == '2') {
						this.getTreeMes = '3';
						if (this.activeNameDevice == 'devicetime') {
							this.searchMaintainGroup({
								pageNum: 1,
								pageSize: this.pageSize,
							});
						} else if (this.activeNameDevice == 'device') {
							this.searchMaintain({
								pageNum: 1,
								pageSize: this.pageSize,
							});
						}
					} else if (data.type == '0') {
						this.getTreeMes = '3';
						//类型
						if (this.activeNameDevice == 'devicetime') {
							this.searchMaintainGroup({
								pageNum: 1,
								pageSize: this.pageSize,
							});
						} else if (this.activeNameDevice == 'device') {
							this.searchMaintainType({
								pageNum: 1,
								pageSize: this.pageSize,
							});
						}
					}

					this.searchMaintainGroup({
						pageNum: 1,
						pageSize: this.pageSize,
					});

					this.$nextTick(() => {
						this.calendarList.id = data.id;
						this.calendarList.type = data.type;
						this.calendarList.year = this.$refs.calendarDisplay.year;
						this.selectRestList(this.calendarList);
					})
				}
			},
			searchMaintain(param) {
				var dataParam = {
					deviceId: this.deviceDetailMes.id,
					type: this.deviceDetailMes.type,
				}
				var newParam = Object.assign(param, dataParam);
				maintenance.getMaintainInfoPage(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableMaintainTeamData = data.data.records
						this.pageCount = data.data.total;
						this.pageSize = data.data.size;
						this.pageNum = data.data.current;
						this.$nextTick(() => {
							this.$refs['tableMaintainTeamDataPageModel'].setCurrent(this.pageNum);
						})
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchMaintainType(param) {
				var dataParam = {
					deviceId: this.deviceDetailMes.id,
					type: this.deviceDetailMes.type,
				}
				var newParam = Object.assign(param, dataParam);
				maintenance.getMaintainTypeInfoPage(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableMaintainTeamData = data.data.records
						this.pageCount = data.data.total;
						this.pageSize = data.data.size;
						this.pageNum = data.data.current;
						this.$nextTick(() => {
							this.$refs['tableMaintainTeamDataPageModel'].setCurrent(this.pageNum);
						})
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchMaintainGroup(param) {
				var dataParam = {
					id: this.deviceDetailMes.id,
					type: this.deviceDetailMes.type
				}
				var newParam = Object.assign(param, dataParam);
				maintenance.getMaintainGroup(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableGroup = data.data.records
						this.pageCount = data.data.total;
						this.pageSize = data.data.size;
						this.pageNum = data.data.current;
						this.$refs['pageModelGroup'].setCurrent(data.data.current);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchPage(param) {
				maintenance.getMaintainPage(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						if (param.type == 0) {
							this.allAreaData = data.data.records
							if (this.allAreaData.length > 0) {
								this.checkCount = {
									numInfoAll: 0,
									numMaintain: 0
								}
								for (let i = 0; i < this.allAreaData.length; i++) {
									this.checkCount.numInfoAll += this.allAreaData[i].num;
									this.checkCount.numMaintain += this.allAreaData[i].maintainNum;
								}
							}
						} else {
							this.allTableData = data.data.records
							if (this.allTableData.length > 0) {
								this.checkCount = {
									numInfoAll: 0,
									numMaintain: 0,
									status2: 0,
									status1: 0,
									status3: 0,
									status0: 0,
								}
								for (let i = 0; i < this.allTableData.length; i++) {
									this.checkCount.numInfoAll += this.allTableData[i].num;
									this.checkCount.numMaintain += this.allTableData[i].maintainNum;
									if (this.allTableData[i].maintainStatus == 2) {
										this.checkCount.status2 += this.allTableData[i].maintainNum;
									} else if (this.allTableData[i].maintainStatus == 1) {
										this.checkCount.status1 += this.allTableData[i].maintainNum;
									}  else if (this.allTableData[i].maintainStatus == 3) {
										this.checkCount.status3 += this.allTableData[i].maintainNum;
									}  else if (this.allTableData[i].maintainStatus == 0) {
										this.checkCount.status0 += this.allTableData[i].maintainNum;
									}
								}
							}
						}
						this.pageCount = data.data.total;
						this.pageSize = data.data.size;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getMaintainStatus() {
				maintenance.getMaintainStatus().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						// this.checkCount = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},

			selectRole() {
				Role.selectRole().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.roleList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			// getRisk() {
			// 	file.getRiskList().then((response) => {
			// 		const data = response.data;
			// 		if (data.code == "1") {
			// 			this.riskList = data.data;
			// 			// for (var i = 0; i < this.riskList.length; i++) {
			// 			// 	this.riskMap[this.riskList[i].key] = this.riskList[i].val
			// 			// 	this.checkList.push(this.riskList[i].key)
			// 			// }
			// 		}
			// 	}).catch((response) => {
			// 		console.log(response)
			// 	})
			// },
			selectRisk(info) {
				let param = {};
				if(info.equipmentId!=undefined){
					param = {
						id: info.equipmentId,
						type: 1
					};
				}else{
					param = {
						id: info.equipmentTypeId,
						type: 0
					};
				}
				file.selectRisk(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.riskList = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchUser(param) {
				var newParam = Object.assign(param, this.searchBao);
				file.selectUserRisk(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.userRisk = data.data.records
						this.pageCountGroup = data.data.total;
						this.pageSizeGroup = data.data.size;
						this.pageNumGroup = data.data.current;
						this.$refs['pageModelGroup2'].setCurrent(this.pageNumGroup);
						this.$nextTick(() => {
							var that = this;
							for (let i = 0; i < this.userRisk.length; i++) {
								this.selectionChange.forEach(function(element) {
									if (element.id == that.userRisk[i].id) {
										that.$refs.singleTable.toggleRowSelection(that.userRisk[i], true)
									}
								});
							}
						})
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			handleSelectionChange(val) {
				for (var i = 0; i < this.userRisk.length; i++) {
					for (var j = 0; j < this.selectionChange.length; j++) {
						if (this.selectionChange[j].id == this.userRisk[i].id) {
							this.selectionChange.splice(j, 1);
							j--;
						}
					}
				}
				for (var i = 0; i < val.length; i++) {
					this.selectionChange.push(val[i]);
				}
			},
			deleteMaintainGroup() {
				if (this.statusBtn != 0) {
					maintenance.deleteMaintainGroup({
						id: this.id
					}).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchMaintainGroup({
								pageNum: 1,
								pageSize: this.pageSize,
								id: this.deviceDetailMes.id,
								type: this.deviceDetailMes.type
							});
							this.$message({
								message: this.$t('msg_23'),
								type: 'success'
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					utils.messageAlert(this.$t('label_836'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			addMaintainGroupdialog() {
				if (this.statusBtn != 0) {
					this.selectionChange = [];
					if (this.dialogDeviceSpot) {
						let list = this.tableDataEdit.maintainChargeId.split(',')
						for (var i = 0; i < list.length; i++) {
							this.selectionChange.push({
								id: list[i]
							})
						}
					}
					this.dialogAddMaintainGroup = true;
					this.searchBao = {
						code: '',
						fullname: '',
						part: '',
						mobile: '',
						roleId: '0',
						skill: [],
					};
					this.searchBao.skill = this.checkList;
					this.searchUser({
						pageNum: 1,
						pageSize: this.pageSizeGroup,
					});
				} else {
					utils.messageAlert(this.$t('label_836'), this.$t('label_358'), this.$t('label_100'));
				}

			},
			addMaintainGroup() {
				if (this.dialogDeviceSpot == true) {
					this.tableDataEdit.maintainChargeId = ''
					this.tableDataEdit.maintainChargeName = ''
					var that = this;
					this.selectionChange.forEach(function(element) {
						that.tableDataEdit.maintainChargeId += element.id + ',';
						that.tableDataEdit.maintainChargeName += element.fullName + ',';
					})
					this.tableDataEdit.maintainChargeId = this.tableDataEdit.maintainChargeId.substring(0, this.tableDataEdit.maintainChargeId
						.length - 1)
					this.tableDataEdit.maintainChargeName = this.tableDataEdit.maintainChargeName.substring(0, this.tableDataEdit.maintainChargeName
						.length - 1)
					this.dialogAddMaintainGroup = false;
				} else {
					var userList = [];
					for (var i = 0; i < this.selectionChange.length; i++) {
						userList.push(this.selectionChange[i].id);
					}
					let param = {
						id: this.deviceDetailMes.id,
						type: this.deviceDetailMes.type,
						userId: userList,
					}
					maintenance.addMaintainGroup(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchMaintainGroup({
								pageNum: 1,
								pageSize: this.pageSize,
								id: this.deviceDetailMes.id,
								type: this.deviceDetailMes.type
							});
							this.dialogAddMaintainGroup = false;
							this.$message({
								message: this.$t('msg_23'),
								type: 'success'
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				}
			},
			start(change) {
				let flag = false;
				if (change == 0) {
					if(this.deviceDetailMes.type==1){
						if (this.tableMaintainTeamData.length <= 0) {
							this.$message({
								message: this.$t('label_834'),
								type: 'warning'
							});
							return;
						}
					}
					for (var i = 0; i < this.tableMaintainTeamData.length; i++) {
						if (this.tableMaintainTeamData[i].maintainChargeName == null || this.tableMaintainTeamData[i].maintainChargeName ==
							'') {
							flag = true;
						}
					}
					if (flag) {
						if (this.tableGroup.length <= 0) {
							flag = true;
						} else {
							flag = false;
						}
					}
				}
				if (flag) {
					this.$message({
						message: this.$t('label_835'),
						type: 'error'
					});
					return;
				}
				var param = {
					change: change,
					id: this.deviceDetailMes.id,
					type: this.deviceDetailMes.type,
					time: this.Readytime + ' 00:00:00',
					planFrom: this.deviceDetailMes.type,
				}
				maintenance.startORstop(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.$message({
							message: this.$t('msg_23'),
							type: 'success'
						});
						this.treeShow = false;
						// this.$nextTick(() => {})
						this.$nextTick(() => {
							this.treeShow = true;
							this.$nextTick(() => {
								let eqId = this.calendarList.type != 1 ? null : this.deviceDetailMes.id;
								let id = this.calendarList.type != 1 ? this.deviceDetailMes.id : this.deviceDetailMes.pid;
								if (this.getTreeMes == '0') { //类型
									this.$refs.tree0.dbSelected(id, eqId);
								} else { //区域
									this.$refs.tree1.dbSelected(id, eqId);
								}
							})
						})
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			    // 计划状态重置方法
    resetHandle() {
      // 确认弹窗
      this.$confirm("确定要重置计划状态吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 构建参数 - 和启动停用一样的参数结构
          let param = {
            id: this.deviceDetailMes.id,
            type: this.deviceDetailMes.type,
            time: this.Readytime + " 00:00:00",
            planFrom: this.deviceDetailMes.type,
            change: 3, // 可以定义一个新状态，比如2表示重置，需要和后端确认
          };

          // 调用接口 - 你需要根据后端接口调整
          maintenance
            .resetPlanStatus(param)
            .then((response) => {
              const data = response.data;
              if (data.code == "1") {
                this.$message({
                  message: "重置成功",
                  type: "success",
                });

                // 刷新树和当前选中项
                this.treeShow = false;
                this.$nextTick(() => {
                  this.treeShow = true;
                  this.$nextTick(() => {
                    let eqId =
                      this.calendarList.type != 1
                        ? null
                        : this.deviceDetailMes.id;
                    let id =
                      this.calendarList.type != 1
                        ? this.deviceDetailMes.id
                        : this.deviceDetailMes.pid;
                    if (this.getTreeMes == "0") {
                      //类型
                      this.$refs.tree0.dbSelected(id, eqId);
                    } else {
                      //区域
                      this.$refs.tree1.dbSelected(id, eqId);
                    }
                  });
                });
              } else {
                this.$message({
                  message: data.message || "重置失败",
                  type: "error",
                });
              }
            })
            .catch((response) => {
              console.log(response);
              this.$message({
                message: "请求失败",
                type: "error",
              });
            });
        })
        .catch(() => {
          // 用户取消操作
        });
    },
			dbSelected(row) {
				if (this.getTreeMes == '0') { //类型
					this.$refs.tree0.dbSelected(row.id, null);
				} else { //区域
					this.$refs.tree1.dbSelected(row.id, null);
				}
			},
			upload(file1) {
				var formData = new FormData();
				formData.append('file', file1.file);
				file.upload(formData).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.tableDataEdit.fileId = data.data
						this.$message({
							message: this.$t('msg_15'),
							type: 'success'
						});
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectRestList(param) {
				this.calendarData = [];
				file.selectEquipmentaintainRest(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.calendarData = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getNowTime() {
				let zeroTime = new Date();
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
				} else {
					this.width = "340px";
				}
			},
		},
		created() {
			this.getMaintainStatus();
			this.selectRole();
			// this.getRisk();
			this.MenuRoleList = this.$store.getters.getMenu;
      this.$set(this.monthOptionsObj, this.$t('label_245'), ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']);
      this.$set(this.monthOptionsObj, this.$t('label_242'), ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']);
      this.$set(this.monthOptionsObj, this.$t('label_238'), ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31']);
		}
	}
</script>

<style>
	.selectGroup .selectChoose .select {
		width: 65%;
	}

	.selectGroup .selectChoose .selectText {
		width: 35%;
	}

	.background2 .treeMes .el-tabs__content {
		height: 91%;
	}
	.right-showbtn-qrcode-background {
		/* position: absolute; */
		width: 10px;
		height: 80px;
		background-color: #9c9c9c;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		margin: auto;
	}
	.right-showbtn {
		width: 10px;
		height: 100%;
		display: flex;
		position: relative;
		z-index: 100000;
	}
</style>



// WEBPACK FOOTER //
// src/pages/maintenance/maintainPlanPage.vue